import { useCallback, useState } from "react";
import "./campus_sticker_settings.css";

export const STICKER_COLOR_STORAGE_KEY = "maviinci_sticker_colors_v2";

export const DEFAULT_STICKER_COLORS = {
    background: "#ffffff",
    invoice: "#000000",
    invoiceNumber: "#c41e3a",
    name: "#1a1a1a",
};

const HEX = /^#[0-9a-fA-F]{6}$/;

export function normalizeStickerColors(raw = {}) {
    const legacy = { ...raw };
    if (legacy.invoicePrefix && !legacy.invoice) legacy.invoice = legacy.invoicePrefix;
    if (legacy.invoiceSuffix && !legacy.invoiceNumber) legacy.invoiceNumber = legacy.invoiceSuffix;

    const out = { ...DEFAULT_STICKER_COLORS };
    Object.keys(DEFAULT_STICKER_COLORS).forEach((key) => {
        const v = String(legacy[key] || "").trim();
        if (HEX.test(v)) out[key] = v.toLowerCase();
    });
    return out;
}

export function loadStickerColors() {
    try {
        const raw = localStorage.getItem(STICKER_COLOR_STORAGE_KEY);
        if (raw) return normalizeStickerColors(JSON.parse(raw));
    } catch (e) {
        console.log("sticker colors load", e);
    }
    return { ...DEFAULT_STICKER_COLORS };
}

export function saveStickerColors(colors) {
    try {
        localStorage.setItem(STICKER_COLOR_STORAGE_KEY, JSON.stringify(normalizeStickerColors(colors)));
    } catch (e) {
        console.log("sticker colors save", e);
    }
}

export function useStickerColors() {
    const [colors, setColors] = useState(() => loadStickerColors());

    const setColor = useCallback((key, value) => {
        setColors((prev) => {
            const next = normalizeStickerColors({ ...prev, [key]: value });
            saveStickerColors(next);
            return next;
        });
    }, []);

    const resetColors = useCallback(() => {
        const next = { ...DEFAULT_STICKER_COLORS };
        saveStickerColors(next);
        setColors(next);
    }, []);

    return { colors, setColor, resetColors };
}

const PICKERS = [
    { key: "background", label: "Background" },
    { key: "invoice", label: "IITKAN" },
    { key: "invoiceNumber", label: "Number" },
];

export function StickerColorPickers({ colors, setColor, resetColors, className = "" }) {
    return (
        <div className={`sticker-color-bar ${className}`.trim()}>
            <span className="sticker-color-title">Sticker colors</span>
            {PICKERS.map(({ key, label }) => (
                <label key={key} className="sticker-color-field">
                    <span>{label}</span>
                    <input
                        type="color"
                        value={colors[key]}
                        onChange={(e) => setColor(key, e.target.value)}
                        aria-label={`${label} color`}
                    />
                </label>
            ))}
            <div
                className="sticker-color-preview"
                style={{ background: colors.background }}
                title="Preview"
            >
                <span style={{ color: colors.invoice }}>IITKAN</span>
                <span style={{ color: colors.invoiceNumber }}>1</span>
                <small style={{ color: colors.name }}>Name</small>
            </div>
            <button type="button" className="sticker-color-reset" onClick={resetColors}>
                Reset
            </button>
        </div>
    );
}
